import {
  HttpBackend,
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {
  EnvironmentProviders,
  Injectable,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';
import { Observable } from 'rxjs';

export const NavvisHttpClientBypass = new InjectionToken<HttpClient>(
  'NavvisHttpClientBypass'
);

@Injectable()
export class CustomHeaderInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = () => {
      return sessionStorage.getItem('navvis-token');
    };

    const clonedRequest = req.clone({
      setHeaders: {
        'X-Authorization': `Bearer ${token()}`,
      },
    });
    return next.handle(clonedRequest);
  }
}

export class HttpInterceptorHandler implements HttpHandler {
  constructor(
    private next: HttpHandler,
    private interceptor: HttpInterceptor
  ) {}

  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return this.interceptor.intercept(req, this.next);
  }
}

export function provideNavVisConfiguration(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: NavvisHttpClientBypass,
      useFactory: (httpBackend: HttpBackend) => {
        const interceptors = [
          new CustomHeaderInterceptor(), // Twój niestandardowy interceptor
        ];

        const interceptingHandler = interceptors.reduceRight(
          (next, interceptor) => new HttpInterceptorHandler(next, interceptor),
          httpBackend as any
        );

        return new HttpClient(interceptingHandler);
      },
      deps: [HttpBackend],
    },
  ]);
}
